import { render, staticRenderFns } from "./Interview.vue?vue&type=template&id=06faa982&scoped=true&"
import script from "./Interview.vue?vue&type=script&lang=js&"
export * from "./Interview.vue?vue&type=script&lang=js&"
import style0 from "./Interview.vue?vue&type=style&index=0&id=06faa982&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06faa982",
  null
  
)

export default component.exports